import { Flex } from 'styling/GlobalStyles'
import { InputWrapper, Label, SwitchContainer } from './Input.styled'
import './toggleButton.css'

interface IToggleButton {
  state: any
  handleChange: any
  label?: string
  name?: string
  maxWidth?: boolean
  start?: boolean
  between?: boolean
}
export const ToggleButton = ({ state, handleChange, label, name, maxWidth, start, between }: IToggleButton) => {
  return (
    <InputWrapper nomarg end={!start}>
      <Flex width={maxWidth ? '100%' : null} height='100%' column={!between} between={between} >
        {label && <Label labelText={label} />}

        <SwitchContainer onClick={() => handleChange(name ?? !state)} >
          <div className={`switch-thumb ${state ? 'thumb-on' : 'thumb-off'}`}></div>
        </SwitchContainer>

      </Flex>
    </InputWrapper>
  )
}
